import React from 'react';

import noop from 'lodash/noop';

import {useOnMount, useOnUnmount} from '@edna/hooks';
import {stopPropagation} from '@edna/utils';

import * as S from './style';

export interface IProps {
  className?: string;
  width?: string;
  children: React.ReactNode;
  onEnter?: TEmptyFunction;
  onExit?: TEmptyFunction;
  closeDataSelector?: string;
  onCloseButtonClick?: TEmptyFunction;
  disabledClose?: boolean;
}

const Modal = React.memo<IProps>(
  ({
    className,
    children,
    width = '600px',
    onEnter = noop,
    onExit = noop,
    closeDataSelector,
    onCloseButtonClick,
    disabledClose = false,
  }) => {
    useOnMount(onEnter);
    useOnUnmount(onExit);

    return (
      <S.Modal
        className={className}
        onMouseDown={(event) => {
          if (disabledClose) {
            event.stopPropagation();
          }
        }}
      >
        <S.WindowWrapper>
          {!disabledClose && (
            <S.CloseIcon
              role="button"
              title="close"
              onClick={onCloseButtonClick ?? onExit}
              data-selector={closeDataSelector}
            />
          )}

          <S.Window width={width} role="button" onMouseDown={stopPropagation}>
            {children}
          </S.Window>
        </S.WindowWrapper>
      </S.Modal>
    );
  },
);

export default Modal;
export const {Window} = S;
export const {ModalCancelButton, ModalSubmitButton} = S;
export const ModalHeader = S.Header;
export const ModalContent = S.Content;
export const ModalActions = S.Actions;
